import React from "react";
import { Box, Stack, Typography } from "@mui/material";
//@ts-ignore
import nodata from "./../../assets/nodata.png";

const NoData = () => {
  return (
    <Stack
      spacing={1}
      sx={{ my: 9 }}
      direction="column"
      justifyContent="center"
      alignItems="center">
      <Box
        sx={{
          width: { xs: 50, sm: 60 },
          height: { xs: 40, sm: 60 },
        }}>
        <img src={nodata} alt="no data" style={{ width: "100%" }} />
      </Box>
      <Typography variant="h4">No Data</Typography>
    </Stack>
  );
};

export default NoData;
